import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from 'file-saver';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { NgProgress } from 'ngx-progressbar';
import { Observable } from 'rxjs/Observable';
import { Modal } from '../../../../node_modules/ngx-modal';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { Country } from "../../shared/interface/country.interface";
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { Utils } from '../../shared/Utils/utils';
import { CommonMessage } from '../common/common-messages';
import { MemberType, SearchResponseType } from '../common/constants';
import { StatusConstants } from '../constants/status.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { DisputeReason } from '../enums/dispute-reason.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { Status } from '../enums/ticket-status.enum';
import { DisputeTypesEnums, SourceType, TicketType } from '../enums/ticket-type.enum';
import { BusinessEntity } from '../interface/businessentity';
import { EmailNotificationFlagIbfo } from '../interface/emailNotificationFlagInfo';
import { FBOResponse } from '../interface/fbo-response';
import { MemberSearchByFboIdResponse } from '../interface/member-search-by-fboid-response';
import { OrderDetailInformation } from '../interface/order-detail-info';
import { OrderInfoForNavigation } from '../interface/order-info-navigate';
import { ProductInformation } from '../interface/product-info';
import { ProfileInformation } from '../interface/profile-info';
import { SearchRequest } from '../interface/search-request';
import { ShippingInformation } from '../interface/shipping-info';
import { CopyToSearchResponse, CopyToUserResponse } from '../interface/ticketingsystem/copy-to-search-response.interface';
import { CopyToUser } from '../interface/ticketingsystem/copy-to-users.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { CreateTicketRequest } from '../interface/ticketingsystem/ticket-create';
import { DeleteModal } from '../models/delete-modal';
import { SearchSettingsModal } from '../models/searchSettings-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { OrderService } from '../services/order.service';
import { DateConstants } from '../constants/date.constants';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";
import { environment } from '../../../environments/environment';
import { DisplayNameFormatPipe } from '../../common/pipes/display-name-format.pipe';
@Component({
    selector: 'dispute-ticket-edit',
    templateUrl: '../templates/template1/views/dispute-ticket-edit.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/tickets-edit.less'
    ],
    providers: [DisplayNameFormatPipe]
})
export class EditDisputeTicket implements OnInit {
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    @ViewChild('subType') subType: ElementRef;
    @Input() distributorInfo: DistributorInfo;
    @Input() tabIndex: number;
    @Input() ticketID: number;
    @Input() isTeamTicket: boolean;
    @Input() isFormTicket: boolean;
    @Input() isFdTicket: boolean;
    ticketingModel: any;
    operatingCountryId: String;
    disputeTicketDistributorInfo: DistributorInfo;
    fboProfileDetail: ProfileInformation;
    sourceEnums = SourceType;
    existFiles: any = [];
    attachmentsLength: number = 0;
    ticketActivityLogList: any[] = [];
    isDesc: Boolean = true;
    sortColumn: String;
    orderInfo: OrderDetailInformation;
    ticketEditForm: FormGroup;
    disputeTypeEnums: any = DisputeTypesEnums;
    ticketTypes: any[];
    subTypes: any[];
    departments = [];
    users = [];
    enableReason: boolean;
    emailNotificationFlagIbfo:EmailNotificationFlagIbfo;
    items: any[] = [];
    userInfo: UserInfo;
    productsInfo: Array<ProductInformation>;
    isTicketAssignPermission: boolean;
    ticketPriorities: any[] = [];
    dueDateFormat: Date;
    dueDate: any; // we are getting Moment Object
    disputeReasons: any[] = [];
    disputeTypes: any[];
    countries: any;
    businessEntities: BusinessEntity[] = [];
    disptueReason: string;
    skipOtherReasonOnLoad: boolean = true;
    skipDeptOnLoad: boolean = true;
    fboIdFound: boolean;
    skipDueDateNStatusOnLoad: boolean = true;
    uploader: any;
    uploadResponse: any = [];
    count: number = 0;
    isTicketCreate: boolean;
    isTicketAssign: boolean;
    invalidMembersearch: boolean;
    isLoading: boolean = false;
    isTicketAddNoteNotes: boolean;
    isTicketView: boolean;
    isSubmitted: boolean;
    isStatusChanged :boolean = false;
    invalidQtyLineItems: string;
    disableCreate: boolean;
    isTicketClosePermission: boolean;
    isTicketReopenPermission: boolean;
    qtyWarning: DeleteModal
    statuses: any[] = [];
    isTicketClosed: boolean;
    ticketCloseForm: FormGroup;
    deleteModal: DeleteModal;
    initialStatuses: any[] = [];
    skipAssignToOnLoad: boolean = true;
    sourceTypesEnum: any = SourceType;
    closedReasons: any[];
    elementoffsetValue: number;
    showDatePicker = false;
    @ViewChild('closeTicketModal') closeTicketPopup: Modal;
    ticketActivityChangeData: String = '';
    @ViewChild('ticketActivityDetailsModal') ticketActivityDetailsModal: Modal;
    @ViewChild('editTicketCancelConfirmationModal') editTicketCancelConfirmationModal : Modal;
    ticketClosed: boolean;
    ticketReopen: boolean;
    fboSearchResultModel: FBOResponse;
    modelSubmit: boolean;
    formInvalid: boolean = false;
    storeInfo: StoreConfig;
    allCountries:any;
    searchComponentSettings: SearchSettingsModal;
    saveTicket = new CreateTicketRequest();
    onloadAttachments: any[] =[];
    orderInfoFornavigation: OrderInfoForNavigation;
    isEmail: boolean;
    memberTypeEnum = MemberTypeEnum;
    memberDetails: any;
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    accountManagePermission: boolean = false;
    accountViewPermission: boolean = false;
    accountRestriction:  boolean = false;

    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];
    memberInfo: any;
    isoCodeThree: string;
    customerServiceAccessLevelId: number = AccessLevel.Customer_Service;
    phoneNumberFormat = CommonConstant.DefaultPhoneNumberFormat;
    maxDescriptionChars = 2000;
    descriptionFocus = false;
    distributorID: number;
    enableFileUploadToPrivate: Boolean = environment.enableFileUploadToPrivate;

    constructor(private _customerservice: CustomerService, private _formbuilder: FormBuilder, private departmentService: DepartmentService
        , private _commonService: CommonService, private _cacheService: CacheService, private ngProgress: NgProgress
        , private _translatePipe: TranslateService, private _messageService: MessageService, private _orderservice: OrderService, private _customerService: CustomerService
        , private _displayNamePipe : DisplayNameFormatPipe, private _http: Http) {
    }
    ngOnInit(): void {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.searchComponentSettings = new SearchSettingsModal(5, 0);
        this.preloadDistributorInfo();
        this.getEmailNotificationFlagInfo(this.userInfo.userId,this.ticketID);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
    }

    getStoreConfig(): void {
        this._orderservice.getStoreInfo(CommonConstant.Default_Country).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.getTicketPriorities();
                this.getDisputeReasons();
                this.getDisputeTypes();
                this.getTicketById(this.ticketID);
                this.getTicketActivityLog(this.ticketID);
                this.getClosedReasons();
                this.getBusinessEntities();
                this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {
                    if (data) {
                        this._cacheService.set(CacheKey.UserInfo, data);
                        this.userInfo = data;
                        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[0] + ']'), AccessLevel.Customer_Service);
                        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[1] + ']'), AccessLevel.Customer_Service);
                        this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[2] + ']'), AccessLevel.Customer_Service);
                        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[3] + ']'), AccessLevel.Customer_Service);
                    }
                });
                this.qtyWarning = new DeleteModal(this.proceedToSave.bind(this),
                    this.cancel.bind(this), this.cancel.bind(this));
                this.qtyWarning.viewActionButtons = true;

                this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
                    this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
                this.deleteModal.viewActionButtons = false;
            }
        });
    }
     /**
     *
     * @param userId getting email notification Flag information
     * @param ticketID
     */
    getEmailNotificationFlagInfo(userId: number, ticketID: number) {
        this._customerservice.getEmailNotificationFlagIbfo(userId, ticketID).subscribe((response) => {
            if (response) {
                this.emailNotificationFlagIbfo = response;
                this.emailNotificationFlagIbfo.ticketNumber=ticketID.toString();
                this.getStoreConfig();
            }
        });
    }

    /**
     * get Dispute ticket Info
     * @param ticketID
     */
    getTicketById(ticketID: number) {
        this._customerservice.getTicketById(ticketID).subscribe((response) => {
            if (response) {
                this.ticketingModel = response;
               this.operatingCountryId = response.operatingCountryId;
                this.getOperatingCountryById(this.operatingCountryId);
                if (this.ticketingModel.countryId) {
                    this.isoCodeThree = this._commonService.getCountry(this.ticketingModel.countryId);
                }
                if(response.attachments) {
                       this.onloadAttachments = response.attachments;
                }
                if (this.ticketingModel.notes && this.ticketingModel.notes.length  > 0) {
                    this.ticketingModel.notes.sort(function  (item1,  item2) {
                        const note1 = new Date(item1.createdDate).getTime(), note2 = new Date(item2.createdDate).getTime()
                        // sort string ascending
                        if (note1 > note2) {
                            return -1;
                        } else if (note1 < note2) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                }
                if (this.ticketingModel.notes) {
                    this.ticketingModel.notes.forEach(note => {
                        note.createdDate = moment.utc(note.createdDate)
                        .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                    });
                }
                if (this.ticketingModel.createdDate) {
                    this.ticketingModel.createdDate = moment.utc(this.ticketingModel.createdDate)
                        .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                }
                if( this.ticketingModel &&  this.ticketingModel.disputes){
                    this.ticketingModel.disputes = sortBy(this.ticketingModel.disputes, 'itemNumber');
                }
                if (this.ticketingModel.dueDate) {
                    this.ticketingModel.dueDate = moment.utc(this.ticketingModel.dueDate)
                        .utcOffset(0).format('DD-MMM-YYYY');
                }

                this.setDefaultForm();
            }
        });
    }
    getOperatingCountryById(operatingCountryId:String){
        this._customerservice.getOperatingCountryById(operatingCountryId).subscribe((response) => {
            if (response) {
                let country = response;
                country ? this.ticketingModel.operatingCountryName = country.name : null;
                this.getAllCountries(country.value);
            }
        });
    }
    setDefaultForm() {
        if (this.onloadAttachments) {
            const attachments = this.onloadAttachments;
            this.existFiles = Object.assign([], attachments);
            this.attachmentsLength = this.existFiles.length;
            this.ticketingModel.attachments = this.onloadAttachments;
        }
        if (this.ticketingModel.dueDate) {
            this.dueDateFormat = new Date(this.ticketingModel.dueDate.split('T')[0])
            this.dueDate = this.momentConstructor(this.ticketingModel.dueDate);
        }

        this.getTicketStatuses();
        this.getTicketTypesAndSubTypes();
        this.setUploaderInfo()
        this.getRecentOrderInformation();
        this.buildForm();
        this.buildProductsForm(this.ticketingModel.disputeTypeId);
        this.getDepartments();
        this.disputeTypeChange(this.ticketingModel.disputeTypeId);
        this.getAssignedUsersByDepartments(this.ticketingModel.departmentId);
        this.fboSearchResultModel = null;
        if (!this.distributorInfo) {
            this.getDistributorInfo(this.ticketingModel.memberId)
        } else {
            this.preloadDistributorInfo();
        }
        if (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order) {
            this.onDisputeReasonChange();
        }
    }
    /*
    set Attachments
    */
    setUploaderInfo() {
        this.uploader = this._customerService.getFileUploader();
        this.uploader.onErrorItem = () => this.onErrorItem();
        this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
    }
    /**
    * Gets fbo / retail oder information from titan
    */
    getRecentOrderInformation() {
        if (this.ticketingModel && this.ticketingModel.orderId) {
            this._orderservice.getRecentOrderInformation(this.ticketingModel.orderId, this.isoCodeThree).subscribe(response => {
                if (response && response.webOrderId) {
                    this.getShipMethodInfo(response);
                    this.orderInfoFornavigation=this._customerService.mapOrderInfoForNavigation(response);
                }
                else {
                    this.getOrderDetails();
                }
            }, error => {
                this.getOrderDetails();
            });
        }
    }
    /**
        * get Ship method Info
        */
    getShipMethodInfo(orderInfo: any) {
        if (orderInfo.orderShippings.length > 0 && orderInfo.orderShippings[0].shipMethodId && orderInfo.storeId) {
            let shipMethodId = orderInfo.orderShippings[0].shipMethodId;
            let storeId = orderInfo.storeId;
            this._customerservice.getShipMethodInfo(storeId, shipMethodId).subscribe(response => {
                if (response) {
                    this.orderInfo = this.mapOrderResponseToModel(orderInfo, response.shippingMethodDisplayName);
                    this.productsInfo = this.orderInfo.productInfo;
                }
                else {
                    this.orderInfo = this.mapOrderResponseToModel(orderInfo);
                    this.productsInfo = this.orderInfo.productInfo;
                }
            }, error => {
                this.orderInfo = this.mapOrderResponseToModel(orderInfo);
                this.productsInfo = this.orderInfo.productInfo;
            });
        }
        else {
            this.orderInfo = this.mapOrderResponseToModel(orderInfo);
            this.productsInfo = this.orderInfo.productInfo;
        }

    }
    /**
     * map order response from titan to order model
     */
    mapOrderResponseToModel(orderResponse: any, shipMethodName?: string): OrderDetailInformation {
        let orderInfo = new OrderDetailInformation();
        if (orderResponse && orderResponse.createdDate) {
            orderInfo.orderDate = moment.utc(orderResponse.createdDate)
                .utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');
        }
        orderInfo.orderNumber = orderResponse.orderNumber || '';
        orderInfo.productInfo = [];
        orderInfo.addresses=orderResponse.addresses;
        if(orderInfo && orderInfo.addresses && orderInfo.addresses.length>0){
        orderInfo.address= orderInfo.addresses[0];
        }
        orderInfo.shippingInfo = new ShippingInformation();
        orderInfo.shippingInfo.shippingMethod = shipMethodName || 'NA';
        if (orderResponse && orderResponse.orderShippings && orderResponse.orderShippings.length > 0) {
            orderInfo.shippingInfo.warehouseName = orderResponse.orderShippings[0].distributionCenter;
            orderInfo.deliveryPreferenceId = orderResponse.orderShippings[0].deliveryPreferenceId;
        } else {
            orderInfo.shippingInfo.warehouseName = null;
        }
        orderInfo.webOrderNumber = orderResponse.webOrderId;
        orderResponse.orderLineItems.forEach((product: any) => {
            let productInfo = new ProductInformation();
            productInfo.itemNumber = product.itemNumber;
            productInfo.cc = product.unitQualificationValue;
            productInfo.price = product.unitPaidPrice;
            productInfo.productDescription = product.productName;
            productInfo.quantity = product.quantity;
            productInfo.sku = product.itemNumber;
            orderInfo.productInfo.push(productInfo);
        });
        orderInfo.productInfo = sortBy(orderInfo.productInfo, 'itemNumber');
        return orderInfo;
    }
    /*
    Get order details from AS400
    */
    getOrderDetails() {
        this._customerservice.getOrderInfoUsingWebOrderNum(this.ticketingModel.orderId.toUpperCase(), this.isoCodeThree).subscribe(response => {
            if (response) {
                this.orderInfo = response;
                this.orderInfoFornavigation = this._customerService.mapOrderInfoForNavigationForNonTitanOrder(response);
                this.productsInfo = response.productInfo;
                this.productsInfo.forEach((product: any) => {
                    product.itemNumber = product.sku;
                });
                this.productsInfo = sortBy(this.productsInfo, 'itemNumber');
                this.orderInfo.address = this._customerservice.mapShippingAddress(this.orderInfo);
            }
        });
    }
    /**
     * get activity log
     * @param ticketID
     */
    getTicketActivityLog(ticketID) {
        if (ticketID) {
            this._customerservice.getActivityLogByTicketId(ticketID).subscribe(response => {
                if (response) {
                    this.ticketActivityLogList = response;
                    if (this.ticketActivityLogList && this.ticketActivityLogList.length > 0) {
                        this.ticketActivityLogList.forEach(x => {
                            if (x.createDate) {
                                x.createDate = moment.utc(x.createDate)
                                    .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                            }
                        });
                    }
                }
            });
        }
    }
    /**
      * Build form
      */
    buildForm() {
        this.ticketEditForm = this._formbuilder.group(
            {
               // countryOffice: [this.ticketingModel.operatingCountryId? this.ticketingModel.operatingCountryId:'', Validators.required],
                operatingCountry: [this.ticketingModel.operatingCountryId? this.ticketingModel.operatingCountryId:'', Validators.required],
                country: [this.isoCodeThree ? this.isoCodeThree : '', Validators.required],
                source: [SourceType.Phone, Validators.required],
                department: [this.ticketingModel.departmentId ? this.ticketingModel.departmentId : '', Validators.required],
                assignTo: [this.ticketingModel.assignedToId ? this.ticketingModel.assignedToId : ''],
                priority: [this.ticketingModel.priorityId ? this.ticketingModel.priorityId : '', Validators.required],
                subType: [this.ticketingModel.subTypeId ? this.ticketingModel.subTypeId : '', Validators.required],
                disputeType: [this.ticketingModel.disputeTypeId ? this.ticketingModel.disputeTypeId : '', Validators.required],
                subject: [this.ticketingModel.subject ? this.ticketingModel.subject : '', Validators.required],
                description: [this.ticketingModel.description ? this.ticketingModel.description : ''],
                dueDate: [this.dueDate ? this.dueDate : ''],
                disputeReason: [this.ticketingModel.orderReasonReasonId ? this.ticketingModel.orderReasonReasonId : '', Validators.required],
                items: this._formbuilder.array([]),
                orderReasonNotes: [this.ticketingModel.orderReasonNotes ? this.ticketingModel.orderReasonNotes : ''],
                notes: [''],
                statusId: [this.ticketingModel.statusId ? this.ticketingModel.statusId : '', Validators.required],
                filePath: [new Array<string>()],
                memberId: [this.ticketingModel ? this.ticketingModel.memberId : ''],
                copyTo: [[]],
                sendMailNotification:[ this.emailNotificationFlagIbfo? this.emailNotificationFlagIbfo.sendMailNotification:false],
                sourceIdentifierValue: [this.ticketingModel ? this.ticketingModel.sourceIdentifierValue : '',
                isNaN(this.ticketingModel.sourceIdentifierValue) ? '' : [Validators.required, Utils.PhoneNumValidationRule, Utils.PhoneNumLengthValidationRule]],
            });
        this.ticketEditForm.controls['disputeType'].patchValue(this.ticketingModel.disputeTypeId);
        if (this.ticketEditForm.controls['memberId'].valid && this.ticketEditForm.controls['memberId'].value
         && this.ticketEditForm.controls['memberId'].value.length === 12) {
            this.ticketEditForm.controls['memberId'].
                setValue(this.ticketEditForm.controls['memberId'].value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1-$2-$3-$4'));
        }
        if(this.ticketingModel.statusId === Status.Closed){
            this.isStatusChanged = true;
            this.ticketEditForm.controls['statusId'].setValue(Status.InProgress);
        }
        this.rebindCopyToUsers();
        this.invalidMembersearch = false;
        this.fboIdFound = false;
        this.disableCreate = false;
        this.isEmail = isNaN(this.ticketEditForm.controls['sourceIdentifierValue'].value);
    }

    /**
     * @description This method used to set value for copy to field
     * @date 2019-11-19
     * @memberof EditWorkTicket
     */
    rebindCopyToUsers(): void {
        if (this.ticketingModel && this.ticketingModel.copyToUsers && this.ticketingModel.copyToUsers.length) {
            const users = [];
            this.ticketingModel.copyToUsers.forEach(item => {
                const user = { value: item.firstName + ' ' + item.lastName + ' ' + item.username,
                display: item.firstName + ' ' + item.lastName + ' ' + item.username,
                displayName: item.firstName + ' ' + item.lastName,
                firstName: item.firstName, lastName: item.lastName, userId: item.userId, username: item.username
                };
                users.push(user);
            });
            this.ticketEditForm.controls['copyTo'].setValue(users);
        }
    }

    /**
     * @description
     * @date 2019-10-16
     * @param {string} [url]
     * @memberof EditDisputeTicket
     */
    searchMemberByFboId(): void {
        this.disableCreate = true;
        if (this.ticketEditForm.controls['memberId'].value) {
            this.fboSearchResultModel = null;
            this.invalidMembersearch = false;
            this.fboIdFound = false;
            let fboId = this.ticketEditForm.controls['memberId'].value;
            fboId = fboId.replace(/-|\s/g, '');
            if (fboId.match(/[a-zA-Z]/) || fboId.length != 12) {
                this.invalidMembersearch = true;
            } else {
                this.ticketEditForm.controls['memberId'].setValue(fboId);
                if (this.ticketEditForm.controls['memberId'].valid && this.ticketEditForm.controls['memberId'].value.length === 12) {
                    this.ticketEditForm.controls['memberId'].setValue(this.ticketEditForm.controls['memberId'].
                        value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1-$2-$3-$4'));
                    this.ticketEditForm.controls['memberId'].updateValueAndValidity();
                }
                const distributorId = this.getDistibutorID();
                this._customerservice.getFBOProfileInfoFromTitan(distributorId).subscribe(response => {
                    if (response && response.isSuccess) {
                        this.disputeTicketDistributorInfo = Object.assign({} as any, this.disputeTicketDistributorInfo);
                        this._commonService.getMemberStatus(+distributorId).subscribe(accountInfo => {
                            const fboId =response.fboId;
                            const firstName =response.firstName;
                            const lastName =response.lastName;
                            const memberlevel = response.memberLevel;
                            if(accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                                this.accountRestriction = true;
                                const memberDetails = {
                                    fboId: fboId,
                                    firstName: firstName,
                                    lastName: lastName,
                                    memberLevel: memberlevel
                                };
                                this.memberDetails = memberDetails;
                                this.ticketEditForm.controls['memberId'].setValue('');
                            } else {
                                this.getFboInformation(response);
                            }
                        })
                    } else {
                        this.getSearchDistributorInfoFromAs400();
                    }
                }, (error: any) => {
                    this.getSearchDistributorInfoFromAs400();
                });
            }
        } else {
            this.fboSearchResultModel = null;
            this.invalidMembersearch = false;
            this.fboIdFound = false;
            this.disableCreate = false;
        }
    }


    getFboInformation(response) {
        if (response.firstName && response.lastName) {
            this.disputeTicketDistributorInfo.name = response.firstName + ' ' + response.lastName;
        }
        if (response.fboId) {
            this.disputeTicketDistributorInfo.distributorId = response.fboId;
        }
        this.ticketingModel.callerName = this.ticketingModel.callerName ? this.ticketingModel.callerName : this.disputeTicketDistributorInfo.name ;
        this.ticketingModel.sourceIdentifierValue = this.ticketingModel.sourceIdentifierValue ? this.ticketingModel.sourceIdentifierValue :
        (this.ticketingModel.sourceId === SourceType.Email || this.ticketingModel.sourceId === SourceType.Online_Form) ? response.emailId : response.mobile;
        this.disableCreate = false;
        this.fboIdFound = true;
    }

    /**
     * @description
     * @date 2019-10-24
     * @private
     * @param {string} [url]
     * @memberof EditWorkTicket
     */
    private getSearchDistributorInfoFromAs400(url?: string): void {
        const searchRequest: SearchRequest = this.prepareMemberByIdRequestForSearch();
        this._customerservice.getSearchResults(searchRequest, url)
            .subscribe((response: MemberSearchByFboIdResponse) => {
                if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length) {
                    const fboMemberDetails =response.fboSearchResultModelList[0];
                    const fboMemberId = +fboMemberDetails.fboId;
                    this._commonService.getMemberStatus(fboMemberId).subscribe(accountInfo => {
                        const firstName =fboMemberDetails.fullName;
                        const fboId = fboMemberDetails.fboId;
                        const memberlevel = this._commonService.getMemberLevel(fboMemberDetails.memberLevelID);
                        if(accountInfo && accountInfo.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                            this.accountRestriction = true;
                            const memberDetails = {
                                fboId: fboId,
                                firstName: firstName,
                                lastName: '',
                                memberLevel: memberlevel
                            };
                            this.memberDetails = memberDetails;
                            this.ticketEditForm.controls['memberId'].setValue('');
                        } else {
                            if (response.status === SearchResponseType.COMPLETED) {
                                this.searchSuccess(response);
                            } else {
                                this.searchPolling(response);
                            }
                        }
                    })
                }
            }, error => {
                this.searchErrorResponse(error);
            }, () => {
                this.isLoading = false;
            });
    }


    private getDistibutorID(): string {
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        const distibutorID = this.ticketEditForm.controls['memberId'].value;
        if (new RegExp(distributorIdPattern).test(distibutorID)) {
            let fboId = distibutorID;
            fboId = fboId.replace(/-|\s/g, '');
            return fboId;
        }
    }
    /**
     * @description
     * @date 2019-10-16
     * @private
     * @returns {SearchRequest}
     * @memberof EditDisputeTicket
     */
    private prepareMemberByIdRequestForSearch(): SearchRequest {
        const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
        const distibutorID = this.ticketEditForm.controls['memberId'].value;
        let searchKey: string;
        let searchValue: string;
        if (new RegExp(distributorIdPattern).test(distibutorID)) {
            let fboId = distibutorID;
            fboId = fboId.replace(/-|\s/g, '');
            searchKey = 'FBOID';
            searchValue = fboId;
        }
        const searchRequest: SearchRequest = {
            pageNumber: 1,
            pageSize: 10,
            sort: 'DESC',
            isAdvancedSearch: false,
            searchBy: 'MEMBER',
            sortOrder: ['fboId'],
            searchCriteria: [
                {
                    searchKey: searchKey,
                    searchValue: searchValue
                }
            ]
        };
        return searchRequest;
    }

    /**
     * @description
     * @date 2019-10-18
     * @param {*} response
     * @memberof EditDisputeTicket
     */
    searchSuccess(response): void {
        if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length > 0) {
            this.fboSearchResultModel = response.fboSearchResultModelList[0];

            this.disputeTicketDistributorInfo = {
                distributorId: (this.fboSearchResultModel.fboId ? this.fboSearchResultModel.fboId : '') as string,
                name: (this.fboSearchResultModel.fullName ? this.fboSearchResultModel.fullName : '') as string,
                contactNumber: (this.fboSearchResultModel.phone ? this.fboSearchResultModel.phone : '') as string,
                email: (this.fboSearchResultModel.email ? this.fboSearchResultModel.email : '') as string,
                level: '',
                memberType: (this.fboSearchResultModel.memberType ? this.fboSearchResultModel.memberType : '') as string,
                memberId: 0,
                memberTypeId: 0
            };
            this.ticketingModel.callerName = this.fboSearchResultModel.fullName ? this.fboSearchResultModel.fullName : '';
            this.ticketingModel.sourceIdentifierValue =
                this.ticketingModel.sourceId === SourceType.Email ? this.fboSearchResultModel.email : this.fboSearchResultModel.phone;
            this.disableCreate = false;
            this.fboIdFound = true;
        } else {
            this.disableCreate = true;
            this.invalidMembersearch = true;
            this.fboIdFound = false;
        }

    }

    /**
     * @description
     * @date 2019-10-16
     * @param {*} response
     * @memberof EditDisputeTicket
     */
    searchPolling(response: any) {
        if ((response.status === SearchResponseType.IN_PROGRESS) || (response.status === SearchResponseType.QUEUED)) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                this.getSearchDistributorInfoFromAs400(response.location);
            }
            else {
                const message: any = this._translatePipe.get('ticketing-system.Member Not Existt');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
                this.disableCreate = true;
                this.invalidMembersearch = true;
            }
        }
    }
    /**
     * @description
     * @date 2019-10-16
     * @param {*} error
     * @memberof EditDisputeTicket
     */
    searchErrorResponse(error: any) {
        this.isLoading = false;
        if (error.validations && error.validations.length > 0) {
            this._commonService.setNotification('', error.validations[0].message, 'error', 0, true, 30);
        }
    }
    /**
     * get ticket types and subtypes
     */
    getTicketTypesAndSubTypes() {
        let operatingCountry = this.ticketingModel.operatingCountryId;
        this.departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
            if (response) {
                this.ticketTypes = response.filter((type: any) => type.value === TicketType.Order);
                if (this.ticketTypes && this.ticketTypes.length > 0) {
                    this.subTypes = this.ticketTypes.find(item => item.value === TicketType.Order).subTypes;
                    if(this.ticketingModel){
                         this.ticketingModel.typeId=this.ticketTypes[0].id;
                    }
                }else{
                    this.subTypes=[];
                }
            }
        });
    }
    /**
     * get deaprtment on change of subtype
     * @param event
     */
    disputeTypeChange(event: any) {
        const disputeTypeId = +event;
        this.ticketEditForm.controls['disputeType'].patchValue(disputeTypeId);
        if (+this.ticketEditForm.controls['disputeType'].value === DisputeTypesEnums.Dispute_Individual_Order && this.checkForOtherReason()) {
            this.enableReason = true;
        }
        else {
            this.enableReason = false;
            this.ticketEditForm.controls['orderReasonNotes'].setValidators(null);
            this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
        }
        if (+this.ticketEditForm.controls['disputeType'].value === DisputeTypesEnums.Dispute_Individual_Order) {
            this.ticketEditForm.controls['disputeReason'].setValidators(null);
            this.ticketEditForm.controls['disputeReason'].setValue('');
            this.skipOtherReasonOnLoad ? '' : this.ticketEditForm.controls['orderReasonNotes'].setValue('');
        }
        else {
            this.ticketEditForm.controls['disputeReason'].setValidators(Validators.required);
            this.skipOtherReasonOnLoad ? '' : this.ticketEditForm.controls['orderReasonNotes'].setValue('');
        }
        this.skipOtherReasonOnLoad = false;
        this.ticketEditForm.controls['disputeReason'].updateValueAndValidity();
        if (disputeTypeId) {
            if (this.ticketingModel.orderId && this.orderInfo && !this.skipDeptOnLoad) {
                if (+disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
                    const arr = <FormArray>this.ticketEditForm.controls.items;
                    arr.controls = [];
                    this.ticketEditForm.controls['items'].updateValueAndValidity();
                    this.items = this.ticketEditForm.get('items') as any;
                    if (this.ticketingModel.disputes.length > 0) {
                        for (let index = 0; index < this.ticketingModel.disputes.length; index++) {
                            this.items.push(this.createItemNumberGroup(this.ticketingModel.disputes[index]));
                        }
                    }
                    else {
                        for (let index = 0; index < this.productsInfo.length; index++) {
                            this.items.push(this.createNewItemNumberGroup(this.productsInfo[index]));
                        }
                    }

                }
                else {
                    const arr = <FormArray>this.ticketEditForm.controls.items;
                    arr.controls = [];
                    this.ticketEditForm.controls['items'].updateValueAndValidity();
                }
            }
            this.skipDeptOnLoad = false;
        }
    }
    /**
     * get Departments By oprating Country Id
     */
    getDepartments() {
        if (this.ticketingModel.operatingCountryId) {
            this._customerservice.getAllDepartmentsByOperatingCountryId(+this.ticketingModel.operatingCountryId).subscribe(response => {
                if (response) {
                    this.departments = response;
                    this.departments.sort(function (item1, item2) {
                        var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase()
                        if (dept1 < dept2) //sort string ascending
                            return -1
                        if (dept1 > dept2)
                            return 1
                        return 0
                    });

                } else {
                    this.departments = [];
                    this.ticketEditForm.controls['department'].setValue('');
                    this.getAssignedUsersByDepartments('');
                }
            });
        } else {
            this.departments = [];
            this.users = [];
        }
    }
    createNewItemNumberGroup(productInfo: ProductInformation): FormGroup {
        return this._formbuilder.group({
            itemNumber: [productInfo.sku],
            quantity: [productInfo.quantity],
            productDescription: [productInfo.productDescription],
            alreadyDisputedQuantity: ['0'],
            newDisputedQuantity: ['0'],
            ticketDisputeReasonId: [''],
            include: new FormControl(false),
            createdBy: [this.userInfo.userId],
            modifiedBy: ['']
        });
    }
    createItemNumberGroup(productInfo: any): FormGroup {
        return this._formbuilder.group({
            itemNumber: [productInfo.itemNumber],
            quantity: [productInfo.quantity],
            productDescription: [productInfo.productDescription],
            alreadyDisputedQuantity: [productInfo.alreadyDisputedQuantity],
            newDisputedQuantity: ['0'],
            ticketDisputeReasonId: [productInfo.ticketDisputeReasonId ? productInfo.ticketDisputeReasonId : '', productInfo.include ? Validators.required : null],
            include: [productInfo.alreadyDisputedQuantity > 0 ? true : false],
            createdBy: [productInfo.createdBy],
            modifiedBy: [this.userInfo.userId],
            id: [productInfo.id]
        });
    }
    /*
    get users based on department
    */
    getAssignedUsersByDepartments(event: any) {
        let departmentId = +event;
         if (!this.userInfo.hasSystemRole) {
              this.isTicketClosePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
            this.isTicketReopenPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[1] + "]"), AccessLevel.Department, departmentId);
         } else {
            this.isTicketClosePermission = true;
            this.isTicketReopenPermission = true;

        }

        this.skipAssignToOnLoad ? '' : this.ticketEditForm.controls['assignTo'].setValue('');
        this.skipAssignToOnLoad = false;
         // as per JIRA #PS2021-1080
        // if (!this.userInfo.hasSystemRole) {
        //     this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[0] + ']'), AccessLevel.Customer_Service);
        // } else {
            this.isTicketAssignPermission = true;
        // }
        // if (!this.isTicketAssignPermission) {
        //     this.ticketEditForm.controls['assignTo'].disable();
        //     this.users = [];
        //     this.ticketEditForm.controls['assignTo'].setValue('');
        //     this.showDatePicker = false;
        //     this.ticketEditForm.controls['dueDate'].disable();
        //     this.ticketEditForm.controls['dueDate'].setValue('');
        // } else {
            this.ticketEditForm.controls['assignTo'].enable();
            if (departmentId) {
                this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
                    if (response) {
                        this.users = response;
                        if (this.users && this.users.length > 0) {
                            this.users = this.users.sort(function (a, b) {
                                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                            });
                        }
                        this.assignToChange();
                    } else {
                        this.users = [];
                        this.ticketEditForm.controls['assignTo'].setValue('');
                    }
                });
            }
        // }
        if (departmentId === 0) {
            this.ticketEditForm.controls['assignTo'].enable();
            this.users = [];
            this.ticketEditForm.controls['assignTo'].setValue('');
        }
    }
    /**
     * enable due date when assigned
     */
    assignToChange() {
        if (!this.ticketEditForm.controls['assignTo'].value) {
            this.skipDueDateNStatusOnLoad ? '' : this.ticketEditForm.controls['dueDate'].setValue('');
        }
        if (this.ticketEditForm.controls['assignTo'].value) {
            this.showDatePicker = true;
            this.ticketEditForm.controls['dueDate'].enable();
        }
        else {
            this.showDatePicker = false;
            this.ticketEditForm.controls['dueDate'].disable();
            this.ticketEditForm.controls['dueDate'].setValidators([]);
        }
        this.ticketEditForm.controls['dueDate'].updateValueAndValidity();
        this.skipDueDateNStatusOnLoad = false;
    }
    /**
     * get priorities lookup
     */
    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
            }
        });
    }

    /**
     * Dispute Type
     */
    getDisputeTypes() {

        this._customerservice.getDisputeTypes().subscribe(response => {
            if (response) {
                this.disputeTypes = response;
                this.disputeTypes = sortBy(this.disputeTypes, 'value');
            }
        });
    }

    /**
    * Dispute Reasons
    */
    getDisputeReasons() {
        this._customerservice.getDisputeReasons().subscribe(response => {
            if (response) {
                this.disputeReasons = response;
                this.disputeReasons = sortBy(this.disputeReasons, 'value');
            }
        });
    }
    /**
    *Dispute Reason for Entire dispute ticket
    */
    onDisputeReasonChange() {
        let disputereasonObj = this.disputeReasons.find(item => item.id === (+this.ticketEditForm.controls['disputeReason'].value));
        this.disptueReason = disputereasonObj ? disputereasonObj.value : '';
        this.enableReason = false;
        this.ticketEditForm.controls['orderReasonNotes'].setValidators(null);
        if ((+this.ticketEditForm.controls['disputeReason'].value) === DisputeReason.Other && (+this.ticketEditForm.controls['disputeType'].value) === DisputeTypesEnums.Dispute_Total_Order) {
            this.enableReason = true;
            this.ticketEditForm.controls['orderReasonNotes'].setValidators(Validators.required);
        }
        if (!this.enableReason) {
            this.ticketEditForm.patchValue({ 'orderReasonNotes': '' });
        }
        this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
        if (this.ticketEditForm.valid && (+this.ticketEditForm.controls['disputeType'].value !== DisputeTypesEnums.Dispute_Individual_Order)) {
            this.disableCreate = false;
            this.formInvalid = false;
        }
    }
    /**
     *
     */
    buildProductsForm(disputeTypeId: any) {
        if (+disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
            this.items = this.ticketEditForm.get('items') as any;
            for (let index = 0; index < this.ticketingModel.disputes.length; index++) {
                this.items.push(this.createItemNumberGroup(this.ticketingModel.disputes[index]));
            }
        }
        else {
            const arr = <FormArray>this.ticketEditForm.controls.items;
            arr.controls = [];
            this.ticketEditForm.controls['items'].updateValueAndValidity();
        }
    }
    /**
     *Dispute Reason change for individual dispute ticket
        */
    individualOrderReasonChange() {
        const items: any = this.ticketEditForm.get('items');
        this.enableReason = false;
        this.ticketEditForm.controls['orderReasonNotes'].setValidators(null);
        if (this.checkForOtherReasonInControls()) {
            this.enableReason = true;
            this.ticketEditForm.controls['orderReasonNotes'].setValidators(Validators.required);
        }
        if (!this.enableReason) {
            this.ticketEditForm.patchValue({ 'orderReasonNotes': '' });
        }
        this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
        this.ticketEditForm.controls['orderReasonNotes'].updateValueAndValidity();
        const createTicketValues: any = this.ticketEditForm.getRawValue();
        if (+createTicketValues.disputeType === DisputeTypesEnums.Dispute_Individual_Order) {
            const individualFormValues: any = createTicketValues.items;
            if (this.ticketEditForm.valid && individualFormValues.filter(res => res.include === true).length) {
                this.disableCreate = false;
            }
        }
    }
    markAsSelected(index: number, items: any) {
        items.controls[index].controls['include'].setValue(true);
        items.controls[index].controls['ticketDisputeReasonId'].setValidators([Validators.required]);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
        this.individualOrderReasonChange();
    }
    deselectLineItem(index: number, items: any) {
        items.controls[index].controls['include'].setValue(false);
        items.controls[index].controls['ticketDisputeReasonId'].setValidators(null);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
        this.individualOrderReasonChange();
    }
    /*
   change Quantity in Individual dispute order
   */
    changeQty(sign: any, index: number) {
        const items: any = this.ticketEditForm.get('items');
        if (sign === '+') {
            items.controls[index].controls['newDisputedQuantity'].setValue(parseInt(items.controls[index].controls['newDisputedQuantity'].value) + 1);
            (+(items.controls[index].controls['newDisputedQuantity'].value) + (+(items.controls[index].controls['alreadyDisputedQuantity'].value))) > 0 ? this.markAsSelected(index, items) : '';
        }
        else if (sign === '-' && (+(items.controls[index].controls['newDisputedQuantity'].value) > 0)) {
            items.controls[index].controls['newDisputedQuantity'].setValue(parseInt(items.controls[index].controls['newDisputedQuantity'].value) - 1);
            (+(items.controls[index].controls['newDisputedQuantity'].value) + (+(items.controls[index].controls['alreadyDisputedQuantity'].value))) <= 0 ? this.deselectLineItem(index, items) : '';
        }
        if (+items.controls[index].controls['newDisputedQuantity'].value > 0) {
            this.formInvalid = false;
        } else if (+items.controls[index].controls['newDisputedQuantity'].value === 0) {
            this.formInvalid = true;
        }
    }
    /**
 * failed to upload file
 * @param item
 * @param response
 * @param status
 * @param headers
 */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification('', 'Failed to upload document. Please try after sometime ', NotificationType.ERROR);
    }
    /**
         * On Successful upload of file
         * @param item
         * @param response
         * @param status
         * @param headers
         */
    onSuccessItem(response: string): any {
        if (response) {
            let res = JSON.parse(response);
            let fileDetails = {
                'userId': this.userInfo.userId,
                'fileName': res.fileName.substr(0, 95),
                'url': res.url,
                'eTag': res.eTag,
                'key': res.key
            }
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this._commonService.createNotification('', 'File Uploaded Successfully', NotificationType.SUCCESS);
                this.saveTicket.attachments = this.saveTicket.attachments ?
                                     this.saveTicket.attachments.concat(this.uploadResponse) : this.uploadResponse;
                this.updateTicketById(this.ticketingModel.id);
            }
        }
        else {
            this._commonService.createNotification('', 'File Not uploaded', NotificationType.ERROR);
        }
        this.ngProgress.done();
    }
    saveAttachments(attachments: any) {
        for (let i = 0; i < this.existFiles.length; i++) {
            let fileDetails = {
                'id': this.existFiles[i].id,
                'userId': this.userInfo.userId,
                'fileName': this.existFiles[i].fileName,
                'url': this.existFiles[i].url,
                'eTag': this.existFiles[i].eTag,
                'key': this.existFiles[i].key
            }
            attachments.push(fileDetails);
        }

        this._customerservice.saveAttachments(attachments, this.ticketingModel.id).subscribe(response => {
            if (response) {
                let res = response;
                let addedNotification: any = this._translatePipe.get('Ticket ' + this.ticketingModel.ticketNumber + ' has been Saved successfully');
                this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                if (this.ticketClosed) {
                    this.closeTicketById();
                }
                else if (this.ticketReopen) {
                    this.reopenTicketById();
                }
                else {
                    this.closeTab();
                }
            }
        });
    }

    downloadDocument(url: string, fileName: string) {
      if (this.enableFileUploadToPrivate) {
        let path = new URL(url).pathname.slice(1);
        let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
        this._customerService.downloadFile(s3Path, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          let downloadNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downloadNotification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      } else {
        this._customerService.downloadDocument(url, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          let downlaodNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downlaodNotification.value, NotificationType.SUCCESS);
        });
      }
    }

    removeExistFiles(key: any, index: number) {
        this.existFiles.splice(index, 1);
        this.attachmentsLength = this.attachmentsLength - 1;
        this.ticketingModel.attachments = this.ticketingModel.attachments.filter(element => {
           return element.key !== key;
        });
    }
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = this.ticketingModel.attachments.length;
            let ticketNumber = this.ticketingModel.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerService.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                item.file.name = fileNameArr[0] + '_' + ticketNumber + '_' + filelength
                + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this.ticketingModel.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }
    /*Check for max of 5 attachments */
    checkMaxAttachments() {
        if (this.uploader.queue) {
            this.attachmentsLength = this.uploader.queue.length;
            while (this.attachmentsLength + this.existFiles.length > 5) {
                this.uploader.queue[this.uploader.queue.length - 1].remove();
                this.attachmentsLength--;
            }
        }
    }
    //check for Dispute Quantity and show warning if it is a dispute ticket
    checkForValidationAndUpdate() {
        this.isSubmitted = true;
        this.disableCreate = true;
        const invalidFields: any = document.querySelectorAll('#UpdateDispute-Ticket-js .ng-invalid');
        window.scrollTo(this.elementoffsetValue, 0)
        if (invalidFields[0]) {
            invalidFields[0].focus();
            this.disableCreate=false;
        }
        let createTicketValues: any = this.ticketEditForm.getRawValue();
        if (createTicketValues.disputeType == DisputeTypesEnums.Dispute_Individual_Order) {
            let individualFormValues: any = createTicketValues.items;
            if (this.productsInfo && !individualFormValues.filter(res => res.include === true).length) {
                this.formInvalid = true;
                return;
            }
        }
        if (this.ticketEditForm.valid) {
            let createTicketValues: any = this.ticketEditForm.getRawValue();
            if (createTicketValues.disputeType == DisputeTypesEnums.Dispute_Individual_Order) {
                let disputes: any[] = createTicketValues.items;
                this.invalidQtyLineItems = '';
                if (disputes.filter(res => (res.alreadyDisputedQuantity + res.newDisputedQuantity) > res.quantity && res.newDisputedQuantity > 0).length > 0) {
                    this.invalidQtyLineItems = disputes.map(function (res) { if ((res.alreadyDisputedQuantity + res.newDisputedQuantity) > res.quantity && res.newDisputedQuantity > 0) { return res.itemNumber } }).join();
                    this.qtyWarning.toggle = true;
                    this.qtyWarning.message = 'The number of disputed items for SKU# ' + this.invalidQtyLineItems + ' exceed the original quantity ordered. If this is correct, click Yes to proceed with this dispute.';
                    this.disableCreate=false;
                }
                else {
                    this.updateTicket();
                }
            }
            else {
                this.updateTicket();
            }
        }
    }
    /**
* on clicking of "No" this method will be called.
*/
    cancel() {
        //data should not be removed...
    }
    // if you click OK in the popup
    proceedToSave() {
        this.updateTicket();
    }
    /**
     * Add disputed individual quantity
     */
    changeDisputedQty(items: any[]) {
        items.forEach(item => {
            if (item.include) {
                item.alreadyDisputedQuantity = item.alreadyDisputedQuantity + (+item.newDisputedQuantity);
            }
            else {
                let disputes: any[] = this.ticketingModel.disputes
                let oldRecord = disputes.find(res => res.id === item.id);
                if (oldRecord && oldRecord.include) {
                    item.include = true;
                }
                else {
                    item.ticketDisputeReasonId = null;
                }
            }
            item.newDisputedQuantity = 0;
        });
        return items;
    }
    updateTicket() {
        let createTicketValues: any = this.ticketEditForm.getRawValue();
        if (this.isTicketAssignPermission && +createTicketValues.assignTo !== (this.userInfo.userId) &&
            (+createTicketValues.statusId === this.ticketingModel.statusId ||
                (+createTicketValues.statusId !== Status.Closed && this.ticketingModel.statusId === Status.Closed && +createTicketValues.statusId !== Status.InProgress))) {
                    if(this.isStatusChanged === true
                        && this.ticketingModel.statusId === Status.Closed
                        && +createTicketValues.statusId === Status.Closed){
                        this.disableCreate = false;
                        this.isTicketClosed = false;
                        this.openCloseTicketModal(true);
                    }
                    else{
                        this.proceedToUpdate();
                    }
        } else if (+createTicketValues.statusId !== Status.Closed && this.ticketingModel.statusId === Status.Closed) {
            this.disableCreate = false;
            if (+createTicketValues.statusId === Status.InProgress) {
                if (this.isTicketReopenPermission) {
                    if(this.isStatusChanged === false){
                        this.isTicketClosed = true;
                        this.openCloseTicketModal(false);
                    }
                    else{
                        this.proceedToUpdate();
                        this.isStatusChanged = false;
                    }
                } else {
                    this.displayAlertBoxOnNoPermissiononReopenTicket(true);
                }
            } else {
                this.isTicketClosed = true;
                this.openCloseTicketModal(true);
            }
        } else if (+createTicketValues.statusId === Status.Closed) {
            if(this.isStatusChanged === true){
                this.disableCreate = false;
                this.isTicketClosed = false;
                this.openCloseTicketModal(true);
            }
            else{
                this.proceedToUpdate();
            }
        } else {
            this.proceedToUpdate();
        }
    }


    disputeTicketEditTransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (this.ticketEditForm.controls['dueDate'].dirty) {
                this.ticketEditForm.controls['dueDate'].setValidators([Utils.validateDate]);
            }
            if (this.ticketEditForm.controls['dueDate'].valid) {
                this.ticketEditForm.controls['dueDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        } else {
            this.ticketEditForm.controls['dueDate'].setValue('');
        }
    }

    proceedToUpdate() {

        let createTicketValues: any = this.ticketEditForm.getRawValue();
        let fboId: string;
        if (this.ticketEditForm.controls['memberId'].value) {
            fboId = this.ticketEditForm.controls['memberId'].value;
            fboId = fboId.replace(/-|\s/g, '');
            this.saveTicket.memberId = fboId;
            this.saveTicket.callerName = this.ticketingModel.callerName;
        } else {
            this.saveTicket.memberId = null;
            this.saveTicket.memberType = null;
            this.saveTicket.callerName = null;
        }
        if (+createTicketValues.disputeType === DisputeTypesEnums.Dispute_Individual_Order) {
            this.saveTicket.disputes = this.changeDisputedQty(createTicketValues.items);
        }
        if (+createTicketValues.disputeType === DisputeTypesEnums.Dispute_Total_Order) {
            this.saveTicket.orderReasonReasonId = createTicketValues.disputeReason;
        }
        this.saveTicket.sourceIdentifierValue = createTicketValues.sourceIdentifierValue;
        this.saveTicket.callerName = this.ticketingModel.callerName;
        this.saveTicket.sourceId = this.ticketingModel.sourceId;
        this.saveTicket.typeId = this.ticketingModel.typeId;
        this.saveTicket.subTypeId = createTicketValues.subType;
        this.saveTicket.description = createTicketValues.description;
        this.saveTicket.departmentId = createTicketValues.department;
        this.saveTicket.priorityId = createTicketValues.priority;
        this.saveTicket.dueDate = createTicketValues.dueDate ? Utils.convertToSpecificDateFormat(createTicketValues.dueDate, DateConstants.DOBFormat) : null;
        this.saveTicket.subject = createTicketValues.subject;
        this.saveTicket.disputeTypeId = Number(createTicketValues.disputeType);
        const distributorInfo = (fboId && this.disputeTicketDistributorInfo && this.disputeTicketDistributorInfo.memberType)
            ? this.disputeTicketDistributorInfo : (fboId && this.distributorInfo ? this.distributorInfo : null);
        if (distributorInfo) {
            if (distributorInfo.memberType === MemberType.RETAIL || distributorInfo.memberType === MemberType.RETAIL_CUSTOMER
                || distributorInfo.memberType === MemberType.RETAILCUSTOMER) {
                this.saveTicket.memberType = MemberType.RETAIL;
            } else if (distributorInfo.memberType === MemberType.GUEST || distributorInfo.memberType === 'G') {
                this.saveTicket.memberType = MemberType.GUEST;
            } else if (distributorInfo.memberType === MemberType.FPC) {
                this.saveTicket.memberType = MemberType.FPC;
            } else {
                this.saveTicket.memberType = MemberType.FOB;
            }

        }
        this.saveTicket.sendMailNotification=this.ticketEditForm.value.sendMailNotification;
        this.saveTicket.id = this.ticketingModel.id;
        this.saveTicket.ticketNumber = this.ticketingModel.ticketNumber;
        this.saveTicket.createdBy = this.ticketingModel.createdBy;
        this.saveTicket.updatedBy = this.userInfo.userId;
        this.saveTicket.userId = this.userInfo.userId;
        this.saveTicket.firstName = this.userInfo.firstName;
        this.saveTicket.lastName = this.userInfo.lastName;
        if (createTicketValues.assignTo) {
            this.saveTicket.assignedToId = +createTicketValues.assignTo;
        }
        this.saveTicket.note = createTicketValues.notes;
        this.saveTicket.statusId = this.saveTicket.assignedToId;
        this.saveTicket.statusId = +createTicketValues.statusId;
        this.saveTicket.operatingCountryId = createTicketValues.operatingCountry;
        this.saveTicket.attachments = this.ticketingModel.attachments;
        this.saveTicket.orderId = this.ticketingModel.orderId;
        this.saveTicket.orderReasonNotes = this.enableReason ? createTicketValues.orderReasonNotes : '';
        this.saveTicket = this.mapCopyToUsers(this.saveTicket);
        this.saveTicket.distributorName = this.saveTicket.memberId ? this.disputeTicketDistributorInfo.name : null;
        this.saveTicket.agentEmail = this.userInfo.email;
        this.saveTicket.agentName = this.userInfo.firstName+' '+this.userInfo.lastName;
        this.saveTicket.ticketLink=window.location.href;
        this.saveTicket.countryId = this._commonService.getCountry(this.isoCodeThree, true);
        if (this.users && this.saveTicket.assignedToId) {
            const assignedToUser = this.users.find(item => item.id === +this.saveTicket.assignedToId);
            if (assignedToUser) {
                this.saveTicket.assignedToEmail = assignedToUser.email;
            }
        }
        if (this.uploader.queue.length > 0) {
            this.uploadFile();
        } else{
         this.updateTicketById(this.ticketingModel.id);
        }
    }

    /**
     * @description This method used to map copyTo users in ticket model
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
    mapCopyToUsers(ticket: CreateTicketRequest): CreateTicketRequest {
        ticket.copyToUsers = [];
        if (this.ticketEditForm.value.copyTo && this.ticketEditForm.value.copyTo.length) {
            this.ticketEditForm.value.copyTo.forEach(item => {
                const user: CopyToUser = {
                    userId: item.userId,
                    username: item.username,
                    firstName: item.firstName,
                    lastName: item.lastName
                };
                ticket.copyToUsers.push(user);
            });
        }
        return ticket;
    }

    updateTicketById(ticketId: number) {
        this._customerservice.updateTicketById(ticketId,this.saveTicket).subscribe(response => {
            if (response) {
                this.disableCreate =false;
                this._messageService.setAuditLogUpdated(true);
                let addedNotification: any = this._translatePipe.get('Ticket ' + this.ticketingModel.ticketNumber + ' has been Updated successfully');
                this._commonService.createNotification('', addedNotification.value, NotificationType.SUCCESS);
                if (this.ticketClosed) {
                    this.closeTicketById(response.memberId);
                }
                else if (this.ticketReopen) {
                    this.reopenTicketById(response.memberId);
                }
                else {
                    this.closeTab(response.memberId);
                }
                this.isSubmitted = false;
            }
        });
    }
    /*
Get ticket Statuses
*/
    getTicketStatuses() {

        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.initialStatuses = response;
                if (this.ticketingModel.statusId === Status.Closed) {
                    this.initialStatuses.forEach((status: any) => { if (status.id === Status.InProgress) { status.value = StatusConstants.Reopen } })
                    this.isTicketClosed = true;
                    this.statuses = this.initialStatuses;
                }
                else {
                    this.statuses = this.initialStatuses;
                }
                this.statuses = sortBy(this.statuses, 'value');
            }
        });
    }
    closeForm() {
        if (this.isTicketClosed) {
            this.ticketCloseForm = this._formbuilder.group(
                {
                    closedTicketReason: [''],
                    closedTicketNote: ['', [Validators.required]]
                });
        } else {
            this.ticketCloseForm = this._formbuilder.group({
                closedTicketReason: ['', [Validators.required]],
                closedTicketNote: ['', [Validators.required]]
            });
        }
    }
    openCloseTicketModal(isCloseTicket: boolean) {
        this.closeForm();
        if (!this.userInfo.hasSystemRole) {
            if(isCloseTicket){
                if (this.isTicketClosePermission) {
                    this.closeTicketPopup.open();
                } else {
                    if (this.ticketingModel.statusId === Status.Closed) {
                        this.closeTicketPopup.open();
                    } else {
                        this.displayAlertBoxOnNoPermissiononCloseTicket(true);
                    }
                }
            } else {
                let createTicketValues: any = this.ticketEditForm.getRawValue();
                if (+createTicketValues.assignTo !== (this.userInfo.userId)) {
                    this.displayAlertBoxOnNoPermissiononReopenTicket(false);
                }
            }
        } else {
            this.closeTicketPopup.open();
        }
    }

    displayAlertBoxOnNoPermissiononCloseTicket(hasPermission: Boolean) {
        this.deleteModal.toggle = true;
        if (hasPermission) {
            this.deleteModal.message = CommonMessage.noPermissionToCloseMessage;
        } else {
            this.deleteModal.message = CommonMessage.noCloseTicketPermissionMessage;
        }

    }
    displayAlertBoxOnNoPermissiononReopenTicket(hasPermission: Boolean) {
        this.deleteModal.toggle = true;
        if (hasPermission) {
            this.deleteModal.message = CommonMessage.noPermissionToReOpenMessage;
        } else {
            this.deleteModal.message = CommonMessage.noReopenTicketPermissionMessage;
        }
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    closeTicket() {
        this.modelSubmit = true;
        if (this.ticketCloseForm.valid) {
            this.ticketClosed = true;
            this.proceedToUpdate();
        }
    }
    closeTicketById(memberId?: string) {

        const formValues = this.ticketCloseForm.getRawValue();
        const ticketInfo = new CreateTicketRequest();
        ticketInfo.closeReasonId = formValues.closedTicketReason;
        ticketInfo.closeReason = formValues.closedTicketNote;
        ticketInfo.id = this.ticketingModel.id;
        ticketInfo.userId = this.userInfo.userId;
        this._customerservice.closeTicketById(this.ticketID, ticketInfo).subscribe(response => {
            if (response) {
                this.closeTab(memberId);
            }
        });
    }
    reopenTicket() {
        this.modelSubmit = true;
        if (this.ticketCloseForm.valid) {
            this.ticketReopen = true;
            this.proceedToUpdate();
        }
    }
    reopenTicketById(memberId?: string) {
        let formValues = this.ticketCloseForm.getRawValue();
        let ticketInfo = new CreateTicketRequest();
        ticketInfo.reopenReason = formValues.closedTicketNote;
        ticketInfo.id = this.ticketingModel.id;
        ticketInfo.userId = this.userInfo.userId;
        this._customerservice.reopenTicketById(this.ticketID, ticketInfo).subscribe(response => {
            if (response) {
                this.closeTab(memberId);
            }
        });
    }
    /**
     * get ticket closing reasons
     */
    getClosedReasons() {
        this._customerservice.getClosedReasons().subscribe((response) => {
            if (response) {
                this.closedReasons = response;
                this.setFocusToTextBox();
            }
        });
    }
    closeTab(memberId?: string) {
        let tabinfo = new TicketTabInfo();
        tabinfo.distributorID = this.distributorInfo ? this.distributorInfo.distributorId : null;
        tabinfo.tabIndex = this.tabIndex;
        tabinfo.ticketID = this.ticketID;
        tabinfo.isTeamTicket = this.isTeamTicket;
        tabinfo.isFormTicket = this.isFormTicket;
        tabinfo.isFdTicket = this.isFdTicket;
        tabinfo.ticketNumber = this.ticketingModel.ticketNumber;
        tabinfo.modifiedDistributor = (this.distributorInfo && memberId
            && this.distributorInfo.distributorId === memberId) ? false : true;
        this._messageService.setClosingTabInfo(tabinfo);
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof EditDisputeTicket
     */
    cancelPopup() {
        this.isSubmitted = false;
        this.modelSubmit = false;
        this.ticketCloseForm.patchValue({ 'closedTicketReason': '' });
        this.ticketCloseForm.patchValue({ 'closedTicketNote': '' });
        this.closeTicketPopup.close();
    }
    /**
     * get member info
     */
    getDistributorInfo(memberId: string) {
        if(memberId){
            this._customerservice.getFBOProfileInfoFromTitan(memberId).subscribe(response => {
                if (response && response.fboId) {
                    this.distributorInfo = response;
                    if (response.firstName && response.lastName) {
                        const middleName = response.displayMiddleName && response.middleName ? response.middleName : '';
                        this.distributorInfo.name = response.firstName + ' ' + (middleName ? middleName + ' ' : '') + response.lastName;
                    }
                    this.distributorInfo.memberType = response.memberType;
                    this.distributorInfo.contactNumber = response.contactNumber;
                    this.distributorInfo.email = response.email;
                    this.distributorInfo.level = response.level;
                    this.memberDetails = response;
                    this.distributorID = response.fboId;
                    // this.getAccountStatus(distributorID);
                    if (response.fboId) {
                        this.distributorInfo.distributorId = response.fboId;
                    }
                    this.preloadDistributorInfo();
                } else {
                    this.getDistributorInfoFromAs400(memberId);
                }
            }, (error: any) => {
                this.getDistributorInfoFromAs400(memberId);
            });
        }
    }
    getDistributorInfoFromAs400(distributorId: string) {
        if(distributorId){
            this._customerservice.getFBOProfileInformation(distributorId, this.ticketingModel.memberType).subscribe(response => {
                if (response) {
                    this.distributorInfo = new DistributorInfo();
                    this.distributorInfo.name = response.firstName + ' ' + response.lastName;
                    this.distributorInfo.distributorId = distributorId;
                    this.distributorInfo.memberType = this.ticketingModel.memberType;
                    this.preloadDistributorInfo();
                }
            });
        }
    }


    private preloadDistributorInfo(): void {
        if (this.distributorInfo) {
            this.disputeTicketDistributorInfo = JSON.parse(JSON.stringify(this.distributorInfo));
            this.disputeTicketDistributorInfo.name = this._displayNamePipe.transform(this.distributorInfo);
        }
    }

    clearTicketForm() {
        this.skipDeptOnLoad = true;
        this.skipDueDateNStatusOnLoad = true;
        this.skipAssignToOnLoad = true;
        this.setDefaultForm();
        if (this.distributorInfo) {
            this.closeTab(this.distributorInfo.distributorId);
        } else {
            this.closeTab();
        }
    }
    setFocusToTextBox() {
        setTimeout(function () {
            if (this.ticketEditForm && this.ticketingModel && this.ticketingModel.disputeTypeId) {
                this.ticketEditForm.controls['disputeType'].setValue(this.ticketingModel.disputeTypeId);
            }
            document.getElementById('subType').focus();
        }, 1000);
    }
    openTicketActivityModal(changedData: String) {
        if (changedData) {
            this.ticketActivityChangeData = changedData;
            this.ticketActivityDetailsModal.open();
        } else {
            this.ticketActivityChangeData = '';
        }
    }
    closeTicketActivityPopup() {
        this.ticketActivityDetailsModal.close();
    }

    closeEditTicketCancelConfirmationPopup(){
        this.editTicketCancelConfirmationModal.close();
    }

    openEditTicketCancelConfirmationPopup(){
        this.editTicketCancelConfirmationModal.open();
    }
    /* on change of Qty */
    selectItem(event: any, index: number, maxQty: number) {
        let inputChar = event.charCode ? String.fromCharCode(event.charCode) : event.target.value;
        if (inputChar !== '+') {
            const items: any = this.ticketEditForm.get('items');
            if (inputChar && Utils.validateNumericCharacterRule(inputChar) && (+inputChar > 0) || (+(items.controls[index].controls['alreadyDisputedQuantity'].value)) > 0) {
                this.formInvalid = false;
                this.markAsSelected(index, items);
            }
            else {
                +inputChar === 0 ? '' : event.preventDefault();
                if (event.target.value === '' || event.target.value === null || +event.target.value === 0 || +inputChar === 0) {
                    this.deselectLineItem(index, items);
                }
            }
        } else {
            event.preventDefault();
        }

    }
    /**
     * check for reason - Other
     */
    checkForOtherReason(): boolean {
        if (this.ticketingModel.disputes.length > 0 && this.ticketingModel.disputes.find((dispute: any) => dispute.ticketDisputeReasonId === DisputeReason.Other)) {
            return true;
        }
        return false;
    }
    /**
 * check for reason - Other in controls
 */
    checkForOtherReasonInControls(): boolean {
        const items: any = this.ticketEditForm.get('items');
        for (let i = 0; i < items.controls.length; i++) {
            if (items.controls[i].controls['ticketDisputeReasonId'].value === DisputeReason.Other) {
                return true;
            }
        }
        return false;
    }

    /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
   requestAutocompleteItems = (searchText: string): Observable<any> => {
    const userSearchList: CopyToUserResponse[] = [];
    const url = ApiUrlConstants.enrollmentApigwUrl + 'csp-agents/search?keyword=' + searchText + '&batchSize=10&pageNumber=1';
    const positionTimeout = 0;
    return this._http
      .get(url)
      .map(res => {
        const response: CopyToSearchResponse = res.json();
        if (response && response.content && response.content.length) {
          response.content.forEach(item => {
            const user = { value: item.firstName + ' ' + item.lastName + ' ' + item.username,
            display: item.firstName + ' ' + item.lastName + ' ' + item.username,
            displayName: item.firstName + ' ' + item.lastName, firstName: item.firstName,
                lastName: item.lastName, userId: item.userId, username: item.username
            };
            userSearchList.push(user);
          });
        }
        this.setOffsetPosition(positionTimeout);
        return userSearchList;
      });
  }

    /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof CreateWorkTicket
    */
    setOffsetPosition(positionTimeout: any): void {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(() => {
            const tagInput: any = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            const dropdownElement: any = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    }

    navigateToFBOProfile(): void {
        this._commonService.getMemberStatus(this.distributorID).subscribe(accountStatus => {
            if( accountStatus && accountStatus.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                this.accountRestriction = true;
                this.memberDetails = this.memberDetails;
            } else {
                if (this.disputeTicketDistributorInfo) {
                    this._cacheService.setSessionValue(CacheKey.DistributorInfo, this.disputeTicketDistributorInfo);
                    window.open(window.location.origin + '/customerservice/search', '_blank');
                    this._cacheService.removeSessionValue(CacheKey.DistributorInfo);
                } else if (this.fboProfileDetail) {
                    this._cacheService.setSessionValue(CacheKey.FboProfileDetail, this.fboProfileDetail);
                    window.open(window.location.origin + '/customerservice/search', '_blank');
                    this._cacheService.removeSessionValue(CacheKey.FboProfileDetail);
                }
            }
        })
    }

    closeModal(status: boolean){
        this.accountRestriction = status;
    }
 /**
  * storeing ordrinfo to session
  */
 navigateToOrderInfo(): void{
     if (this.orderInfo.webOrderNumber) {
        this._cacheService.setSessionValue(CacheKey.ORDER_INFO_SESSION_CODE, this.orderInfoFornavigation);
         window.open(window.location.origin + '/customerservice/search', '_blank');
        this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
    }
}

getBusinessEntities() {
    this._customerservice.getAllBusinessEntities().subscribe(response => {
        if (response) {
            this.businessEntities = response;
            this.getAllowedCountries();
            }
    });
}
getAllowedCountries() {
    let countryIds: any = [];
    if (!this.userInfo.hasSystemRole) {
        if (this.userInfo.allowedOperatingCountries) {
            countryIds = this.userInfo.allowedOperatingCountries.split(",");
            if (this.userInfo.privileges.departments) {
                countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
            }

            countryIds = countryIds ? countryIds : [];
            if (countryIds.length > 0) {
                var ids = countryIds;
                this.countries = this.businessEntities.filter(function (item) {
                    return ids.indexOf(item.id + "") != -1;
                });
            }
        }
        else {
            this.countries = this.businessEntities;
        }
    }
    else {
        this.countries = this.businessEntities;
    }
    this.countries.sort(function (item1, item2) {
        var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase()
        if (country1 < country2) //sort string ascending
            return -1
        if (country1 > country2)
            return 1
        return 0
    });
    const usaInfo = this.countries.find((country: any) => country.id === OperatingCountryEnums.USA);
    if (usaInfo) {
        this.countries.splice(this.countries.indexOf(usaInfo), 1);
        this.countries.splice(0, 0, usaInfo);
    }
}

operatingCountryChange(id: any) {
    if (id) {
        if (this.countries && this.countries.length) {
            const selectedCountry = this.countries.find((country: Country) => country.id === +id);
            if (selectedCountry) {
                this.getAllCountries(selectedCountry.value);
                }
        }
        this.ticketEditForm.controls['subType'].setValue('');
        this.ticketEditForm.controls['department'].setValue('');
        this.ticketEditForm.controls['assignTo'].setValue('');
        this.operatingCountryId = id;
        this.getTicketTypesAndSubTypes();
        this.uploader = this._customerservice.getFileUploader();
        this.uploader.onErrorItem = () => this.onErrorItem();
        this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
        this.getDepartments();
    }
}

/**
     * @description getting countries under operating country
     * @date 2020-03-06
     * @param {string} countryCode
     * @memberof CreateDisputeTicket
     */
    getAllCountries(countryCode: string): void {
        this._customerservice.getCountriesByOperatingCountry(countryCode).subscribe(response => {
            if (response && response.countriesUnderOperatingCountry.length) {
                this.allCountries = response.countriesUnderOperatingCountry.filter(country => country.countryCode === country.companyCode);
            }
        });
    }
   /**
     * @description injecting isocodethree of the selected country
     * @date 2020-11-02
     * @param {string} countryCode
     * @memberof CreateDisputeTicket
     */
    getCountryIsoCodeThree(countryCode: string) {
        if (this.allCountries) {
            this.isoCodeThree = this.allCountries.find((country: any) => country.countryCode === countryCode).companyCode;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/dispute-ticket-edit.component.ts